import { m8API } from 'services/production/m8';
import { ChangePartnerEmailService } from 'types/services';

export const changePartnerEmail: ChangePartnerEmailService = async (
  emailFormValuse,
  partnerId
) => {
  await m8API.admin.updatePartnerLogin({
    idPartner: partnerId,
    login: emailFormValuse.email,
  });
};
